export default "__VITE_ASSET__YXhIJ1T9__"